module.exports = __webpack_public_path__ + "assets/img/30_711.f18fe5b1.jpg";